module.exports = __webpack_public_path__ + "img/symbol_6.2c1be02d.png";